import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

interface ISimilarWordsProps {
    similarWords: string[];
}

export default function SimilarWords(props: ISimilarWordsProps) {
    return (
        <Grid>
            <Grid container>
                <Typography variant="body1" justifyContent="space-between" alignItems="center" paddingRight="6px">Similar Words Included:</Typography>
                <Typography variant="body1" color='#1d8abf' justifyContent="space-between" alignItems="center">{
                    props.similarWords
                        .map((word, index) =>
                            index < props.similarWords!.length - 1 ?
                                word + ", "
                                : word
                        )}
                </Typography>
            </Grid>
        </Grid>
    );
}